import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "Pricing",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.PRICING.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.PRICING.PERMISSIONS,
    },
    component: () => import("@/modules/Pricing/views/Pricing.vue"),
  },
];

export default routes;
